module.exports = __webpack_public_path__ + "static/media/JiaoYu3.bfde6e04.png";